export function mobileLayout(screen, tabCount = 8) {
  const width = Math.max(1, screen.width), height = Math.max(1, screen.height);
  const safe = Object.fromEntries(['top', 'right', 'bottom', 'left'].map(key =>
    [key, Math.max(0, Number(screen.safeArea?.[key]) || 0)]));
  const compact = width < 900 || height < 500;
  const landscape = width > height;
  const usable = Math.max(1, width - safe.left - safe.right);
  const textureDimension = value => Math.round(value * 2) / 2;
  const navWidth = textureDimension(Math.max(1, Math.min(usable - (compact ? 24 : 40),
    compact ? (landscape ? 760 : 440) : Math.min(900, Math.max(600, usable * .62)))));
  const singleRow = navWidth >= tabCount * 72;
  const cols = compact && !landscape ? Math.min(tabCount, 4)
    : singleRow ? tabCount : Math.min(tabCount, Math.max(1, Math.min(Math.ceil(tabCount / 2), Math.floor(navWidth / 72))));
  const rows = Math.ceil(tabCount / cols);
  const navHeight = textureDimension(rows * (landscape && compact ? 48 : 54) + 8);
  const nav = { x: safe.left + (usable - navWidth) / 2,
    y: height - safe.bottom - navHeight - 8, width: navWidth, height: navHeight };
  const statusWidth = textureDimension(Math.max(1, Math.min(usable - 76,
    compact ? (landscape ? 210 : Math.max(176, Math.min(210, usable * .46))) : Math.max(270, Math.min(330, usable * .24)))));
  const status = { x: safe.left + 12,
    y: safe.top + (screen.isWeChat ? 8 : 14), width: statusWidth, height: textureDimension(compact ? 54 : 42) };
  const panelWidth = Math.min(usable - 16, compact ? 440 : 520);
  const panel = { x: compact && !landscape ? safe.left + (usable - panelWidth) / 2 : width - safe.right - panelWidth - 8,
    y: status.y + status.height + 8, width: panelWidth,
    height: Math.max(60, nav.y - status.y - status.height - 16) };
  return { compact, landscape, safe, nav, status, panel, cols, rows };
}

export function insideRect(rect, x, y) {
  return Boolean(rect && x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height);
}

export function panelScrollGeometry(contentHeight, viewHeight, scale, scroll = 0) {
  const header = 150;
  const visible = viewHeight / scale;
  const overflow = contentHeight > visible;
  // In short windows a paging footer would consume the remaining content area.
  // Keep the close/header controls and let pointer scrolling reach the body.
  const footer = overflow && visible >= 420 ? 150 : 0;
  const body = Math.max(1, visible - header - footer);
  const maxScroll = Math.max(0, contentHeight - header - body);
  return { header, footer, body, visible, maxScroll, scroll: Math.max(0, Math.min(maxScroll, scroll)) };
}

export function panelPoint(rect, geometry, x, y) {
  if (!insideRect(rect, x, y)) return null;
  const localX = (x - rect.x) * 1024 / rect.width;
  const viewY = (y - rect.y) * 1024 / rect.width;
  const kind = viewY < geometry.header ? 'header'
    : geometry.footer && viewY >= geometry.visible - geometry.footer ? 'footer' : 'body';
  return { x: localX, y: viewY + (kind === 'body' ? geometry.scroll : 0), kind };
}

export function wrapCanvasText(ctx, text, width, maxLines = 2) {
  const measure = value => {
    const measured = ctx.measureText?.(value)?.width;
    return Number.isFinite(measured) ? measured : value.length * (parseFloat(String(ctx.font || '').match(/\d+(?=px)/)?.[0]) || 40);
  };
  const lines = []; let line = '';
  for (const character of String(text)) {
    if (line && measure(line + character) > width) { lines.push(line); line = ''; }
    line += character;
  }
  if (line) lines.push(line);
  if (lines.length > maxLines) {
    lines.length = maxLines;
    let last = lines[maxLines - 1];
    while (last && measure(last + '…') > width) last = last.slice(0, -1);
    lines[maxLines - 1] = last + '…';
  }
  return lines;
}
